import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { StyledMaxWidth } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../translations';
import { DiagnosisSelector } from '../../common/DiagnosisSelector';
import { MedicalLeaveFormSection } from '../../common/formSections/MedicalLeaveFormSection';
import { MedicalLeaveFormBean } from '../medicalLeave.types';

type MedicalLeaveFormDiagnosisSection = {
   readonly register: BindingCreator<MedicalLeaveFormBean>;
   readonly visitDiagnoses: VisitDiagnosis[];
   readonly required?: boolean;
};

const MedicalLeaveFormDiagnosisSection = (props: MedicalLeaveFormDiagnosisSection): JSX.Element => {
   return (
      <MedicalLeaveFormSection title={commonTranslationKeys.diagnosis} withRequiredMark={props.required}>
         <StyledMaxWidth maxWidth={600}>
            <DiagnosisSelector
               name={'diagnosis'}
               register={props.register}
               required={props.required}
               visitDiagnoses={props.visitDiagnoses}
            />
         </StyledMaxWidth>
      </MedicalLeaveFormSection>
   );
};

export { MedicalLeaveFormDiagnosisSection };
